<div class="popup-container">
  <div class="popup-header">
    <h2>Configure WhatsApp Business</h2>
    <p class="subtitle">Set up your integration settings and authentication</p>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="instructions-box">
    <p class="instructions-title">
      <mat-icon style="color: #310737;">info</mat-icon>
      WhatsApp Business API Setup
    </p>
    <p class="instructions-text">
      Set up WhatsApp Business API through Meta Business platform and get your credentials.
    </p>
    <a href="https://business.facebook.com/" target="_blank" class="doc-link">
      <mat-icon inline>launch</mat-icon> WhatsApp Business
    </a>
  </div>

  <form class="form-section" #form="ngForm" (ngSubmit)="save()" novalidate>
    <div class="form-field">
      <label>Phone Number ID *</label>
      <input type="text" name="phone" placeholder="WhatsApp Business Phone Number ID" required [(ngModel)]="formData.phone" />
    </div>

    <div class="form-field">
      <label>Access Token *</label>
      <input type="text" name="token" placeholder="WhatsApp Business Access Token" required [(ngModel)]="formData.token" />
    </div>

    <div class="form-field">
      <label>Webhook Verify Token</label>
      <input type="text" name="verifyToken" placeholder="Webhook verification token" [(ngModel)]="formData.verifyToken" />
    </div>

    <div class="dialog-footer">
<button mat-stroked-button type="button" (click)="close()" class="cancel-button">
  Cancel
</button>

        <button mat-flat-button color="primary" class="save-config-btn" [disabled]="form.invalid" type="submit">
  Save Configuration
</button>

    </div>
  </form>
</div>
